<!--
 * @Author: your name
 * @Date: 2021-08-27 20:47:21
 * @LastEditTime: 2022-02-23 17:27:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \rightcloud-console\src\views\console\dashboard\individual\components\consumption.vue
-->

<template>
    <div class="card"
         style="padding-bottom:10px;">
        <div class="title">{{$t('消费情况')}}</div>
        <ul class="bill-pack">
            <li>
                <span>{{this.$t('历史消费')}}</span>
                <b>{{$money(expenseObj.historyExpense,5)}}</b>
            </li>
            <li>
                <span>{{this.$t('上月消费')}}</span>
                <b>{{$money(expenseObj.lastMonthExpense,5)}}</b>
            </li>
            <li>
                <span>{{this.$t('本月消费')}}</span>
                <b>{{$money(expenseObj.currentMonthExpense,5)}}</b>
            </li>
        </ul>
    </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import API from '@/service/api'
export default {
    name: 'consumption',
    props: ['expenseObj'],
    components: {
    },
    data () {
        return {

        }
    },
    mounted () {
    },
    methods: {
    }
}
</script>
<style lang="less" scoped>
.bill-pack {
    height: calc(100% - 50px);

    li {
        background: #f5f6f7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 5% 10px 5%;
        margin: 5px 15px !important;
        span {
            height: 30%;
            display: block;
        }
    }
}
</style>
